"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCampaign = function IconCampaign(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m20.465 6.322 21.213 21.214a1 1 0 0 1-1.415 1.414L19.05 7.737a1 1 0 0 1 1.415-1.415m-2.829-1.414a3 3 0 0 1 4.243 0l8.025 8.025 2.146-.368a2.932 2.932 0 0 1 3.385 3.385l-.368 2.146 8.025 8.025a3 3 0 0 1-4.243 4.243L17.636 9.151a3 3 0 0 1 0-4.243m15.006-.55v6h-1v-6zm1.808 11.423-.245 1.429-3.415-3.414 1.429-.245a1.932 1.932 0 0 1 2.23 2.23m9.192-.423h-6v1h6zM39.91 7.383l-4.243 4.243.707.707 4.243-4.243zm-25.851 23.73 3.535-3.536.707.707-3.535 3.536zm5.657-1.415-3.536 3.536.707.707 3.536-3.535zm-1.959 10.444-1.535 1.536a4 4 0 0 1-5.657 0l-4.243-4.243a4 4 0 0 1 0-5.657l11.314-11.313V9.15l2 2v8.485l8.728 8.728h8.485l2 2H27.536l-6.243 6.243 6.717 6.717a2.5 2.5 0 0 1-3.535 3.536zM19.05 21.88l7.071 7.07-6.242 6.243-3.536 3.536-1.535 1.535a2 2 0 0 1-2.829 0l-4.242-4.242a2 2 0 0 1 0-2.828zm.829 16.142 6.717 6.717a.5.5 0 0 1-.707.707l-6.717-6.717z",
    clipRule: "evenodd"
  })));
};

export { IconCampaign, IconCampaign as default };
